import { Business } from 'model';
import { useCurrentUser } from '../hooks/useCurrentUser.js';
import { IonText } from '@ionic/react';
import { IconTime, IconCheckCircle } from './QuirkIcons/index.js';
import { StatusBanner } from './StatusBanner.js';
export interface BusinessStatusBannerProps {
	business: Business;
}
export function BusinessStatusBanner({ business }: BusinessStatusBannerProps) {
	const user = useCurrentUser();
	const isPendingSubmission = business.submissionStatus === 'pending';
	const isPendingClaim = business.claimStatus === 'pending';
	const isOwner = business.owner === user._id;
	const isSubmitter = business.submittedBy === user._id;
	return (
		<>
			{!isPendingSubmission && isPendingClaim && isOwner && (
				<StatusBanner status="pending">
					<IonText>You've claimed this business, claim is under review</IonText>
					<IconTime size="large" />
				</StatusBanner>
			)}
			{business.claimStatus === 'claimed' && isOwner && (
				<StatusBanner status="approved">
					<IonText>You've claimed this business</IonText>
					<IconCheckCircle size="large" />
				</StatusBanner>
			)}
			{isPendingSubmission && isSubmitter && (
				<StatusBanner status="pending">
					<IonText>You've suggested this business, suggestion is under review</IonText>
					<IconTime size="large" />
				</StatusBanner>
			)}
		</>
	);
}
